export default "__VITE_ASSET__502b4ef7__"